import {Box, Stack, Typography} from '@customink/pigment-react';
import React from 'react';
import ProductDescription from './ProductDescription';
import ProductDetails from './ProductDetails';

export default function ProductDescriptionAndFeatures() {
  return (
    <Stack>
      <Typography variant="h6">Description and Features</Typography>
      <Box sx={{display: 'flex', gap: '2rem'}}>
        <Box sx={{flex: 1}}>
          <ProductDescription />
        </Box>
        <Box sx={{flex: 1}}>
          <ProductDetails />
        </Box>
      </Box>
    </Stack>
  );
}
